import { makeStyles, Theme, Typography } from '@material-ui/core';
import { Entity } from '@backstage/catalog-model';
import { ToolItem } from './ToolItem';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(2.5),
    '&:first-of-type': {
      marginTop: theme.spacing(1.5),
    },
  },
  heading: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(0.25),
  },
  label: {
    whiteSpace: 'nowrap',
  },
  rule: {
    flex: 1,
    border: 0,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

type ToolCategorySectionProps = {
  categoryId: string;
  title: string;
  tools: Entity[];
};

export const ToolCategorySection = ({
  categoryId,
  title,
  tools,
}: ToolCategorySectionProps) => {
  const classes = useStyles();
  const headingId = `tools-category-${categoryId}`;

  return (
    <section className={classes.root} aria-labelledby={headingId}>
      <div className={classes.heading}>
        <Typography
          id={headingId}
          variant="h6"
          component="h2"
          className={classes.label}
        >
          {title}
        </Typography>
        <hr className={classes.rule} />
      </div>
      <div>
        {tools.map(tool => (
          <ToolItem key={tool.metadata.uid ?? tool.metadata.name} tool={tool} />
        ))}
      </div>
    </section>
  );
};
